"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles = __importStar(require("./Header.module.css"));
exports.default = (function () { return (react_1.default.createElement("header", { className: styles.header },
    react_1.default.createElement("div", { className: styles.sectionHeader },
        react_1.default.createElement("img", { src: "/img/logo.jpg", alt: "intellitec-logo" })))); });
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSGVhZGVyLmpzIiwic291cmNlUm9vdCI6Ii4vIiwic291cmNlcyI6WyJwZGYvZm9ybXMvaW50ZWxsaXRlYy9Db21tb25TZWN0aW9ucy9IZWFkZXIvSGVhZGVyLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7QUFBQSxnREFBeUI7QUFDekIsMERBQTZDO0FBRTdDLG1CQUFlLGNBQU0sT0FBQSxDQUNqQiwwQ0FBUSxTQUFTLEVBQUUsTUFBTSxDQUFDLE1BQU07SUFDNUIsdUNBQUssU0FBUyxFQUFFLE1BQU0sQ0FBQyxhQUFhO1FBQ2hDLHVDQUFLLEdBQUcsRUFBQyxlQUFlLEVBQUMsR0FBRyxFQUFDLGlCQUFpQixHQUFPLENBQ25ELENBQ0QsQ0FDWixFQU5vQixDQU1wQixFQUFBIn0=